import React, {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, toasterrormsg, useMenuIdPermissions} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import {MixedWidget17} from '../../../_metronic/partials/widgets'
import {HotelDetailsHeader} from './HotelDetailsHeader'
import Swal from 'sweetalert2'
import {Tr} from '../../../_metronic/i18n/Tr'

const ViewRoomsList: FC = () => {
  let t = Tr()
  const location = useLocation()
  const editHotelId = (location.state as any)?.hotelId || ''
  const {menuId, menuIdEdit, menuIdDelete} = useMenuIdPermissions()
  
  // -------- state start ------------
  const [editRoomId, setEditRoomId] = useState('')
  const [hotelDetails, setHotelDetails] = useState([])
  const [primLanguage, setPrimLanguage] = useState('')

  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9)
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayRoomList, setDisplayRoomList] = useState([])
  const [pageNumbersList, setPageNumberList] = useState([1])
  // ----------- state end ------------

  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2)
    let startPage = Math.max(1, currentPage - halfMaxPages)
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1)
    }

    // Generate the list of page numbers
    const pageNumbers = []
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers
  }
  // on page change function
  const onPageChange = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = hotelDetails.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit
        } else {
          tolimi = pageId * limit + limit
        }
      } else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = hotelDetails.slice(tmp, tolimi)
      setDisplayRoomList(tmpdata)
    }
  }

  // ------------------------------------- apis call ------------------------------------
  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: editHotelId,
      // hotelId:'16',
    }
    var response: any = await fetchData('vendor/public/hotelDetailsV2', param)

    if (response.status == '200') {
      var roomList = response.data[0]['roomList']
      setHotelDetails(roomList)
      setPrimLanguage(response.data[0]['primaryLanguage'])
      var tmp: any = roomList.slice(offset, offset + limit)
      setDisplayRoomList(tmp)
      var totpag = Math.ceil(roomList.length / limit)
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = roomList.length % limit
        if (mod > 0) {
          setTo(mod)
        } else {
          setTo(tmp.length)
        }
      } else {
        var mod = roomList.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        } else {
          setTo(page * limit)
        }
      }
      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)
    } else {
      toasterrormsg(response.message)
    }
  }

  //   delete hotel api call
  const confirmdelete = (roomId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          roomId: roomId,
        }
        var res = await fetchData('vendor/public/deleteRoom', param)

        if (res.status == '200') {
          hotelDetailsApiCall()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }

  useEffect(() => {
    hotelDetailsApiCall()
  }, [editRoomId])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('View Rooms')}</PageTitle>
      <ToastContainer />
      <HotelDetailsHeader />
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {displayRoomList.map((room: any, index: any) => {
          var description = ''
          var roomName = ''
          if (primLanguage == 'English') {
            description = room['en_description']
            roomName = room['en_roomName']
          } else if (primLanguage == 'Russian') {
            description = room['ru_description']
            roomName = room['ru_roomName']
          } else if (primLanguage == 'Uzbek') {
            description = room['uz_description']
            roomName = room['uz_roomName']
          }
          return (
            <div className='col-xl-4' key={index}>
              <MixedWidget17
                className='card-xl-stretch mb-5 mb-xl-8'
                color='success'
                roomId={room['roomId']}
                deleteRoom={confirmdelete}
                roomName={roomName}
                image={room['images'].length != 0 ? room['images'][0].thumbPath : ''}
                description={description}
                maxPeople={room['maxPeople']}
                progress='100%'
                showDelete={menuIdDelete}
                showEdit={menuIdEdit}
                menuId={menuId}
              />
            </div>
          )
        })}
      </div>
      {hotelDetails.length != 0 ? (
        <>
          <div className='d-flex flex-stack flex-wrap pt-10'>
            <div className='fs-6 fw-bold text-gray-700'>
              Showing {from} to {to} of {hotelDetails.length} entries
            </div>

            <ul className='pagination'>
              <li className={`page-item previous ${page > 1 ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page > 1 ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => onPageChange(page - 1)}
                >
                  <i className='previous'></i>
                </span>
              </li>
              {pageNumbersList.map((item: any) => {
                return (
                  <li className={`page-item cursor-pointer ${page == item ? 'active' : ''}`}>
                    <span className='page-link' onClick={() => onPageChange(item)}>
                      {item}
                    </span>
                  </li>
                )
              })}

              <li className={`page-item next ${page + 1 <= totalPage ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page + 1 <= totalPage ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => (page + 1 <= totalPage ? onPageChange(page + 1) : '')}
                >
                  <i className='next'></i>
                </span>
              </li>
            </ul>
          </div>
        </>
      ) : (
        ''
      )}
      {/* end::Row */}
    </>
  )
}

export {ViewRoomsList}
